import React from 'react';
import AssignmentFeeRevenueByIndustry from './AssignmentFeeRevenueByIndustry';
import AssignmentFeeRevenueByService from './AssignmentFeeRevenueByService';
import LineItemFeeRevenueByIndustry from './LineItemFeeRevenueByIndustry';
import LineItemFeeRevenueByType from './LineItemFeeRevenueByType';
import AssignmentLineItemFeeRevenueByIndustry from './AssignmentLineItemFeeRevenueByIndustry';
import { makeReportOpener } from '../reportNavTools';

// linkClick: the redux link_click action, bound by the admin page.
export default function buildRevenueMetricsReportsSections(linkClick) {
  const open = makeReportOpener(linkClick);

  return [
    {
      title: 'Reports',
      cards: [
        {
          title: 'Assignment Fee Revenue by Industry',
          description: 'Open assignment-fee revenue broken down by industry.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-industry',
          onClick: () =>
            open(
              <AssignmentFeeRevenueByIndustry />,
              'Assgn. Fee Revenue by Industry',
              'reports_assignmentfeerevenuebyindustry'
            ),
        },
        {
          title: 'Assignment Fee Revenue by Service',
          description: 'Open assignment-fee revenue broken down by service.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-bell-concierge',
          onClick: () =>
            open(
              <AssignmentFeeRevenueByService />,
              'Assgn. Fee Revenue by Service',
              'reports_assignmentfeerevenuebyservice'
            ),
        },
        {
          title: 'Line Item Fee Revenue by Industry',
          description: 'Open line-item fee revenue broken down by industry.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-industry',
          onClick: () =>
            open(
              <LineItemFeeRevenueByIndustry />,
              'Line Item Fee Revenue by Industry',
              'reports_lineitemfeerevenuebyindustry'
            ),
        },
        {
          title: 'Line Item Fee Revenue by Type',
          description: 'Open line-item fee revenue broken down by type.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-shapes',
          onClick: () =>
            open(<LineItemFeeRevenueByType />, 'Line Item Fee Revenue by Type', 'reports_lineitemfeerevenuebytype'),
        },
        {
          title: 'Assignments + Line Items Fee Revenue by Industry',
          description: 'Open combined assignment and line-item fee revenue by industry.',
          fmt: 'REPORT',
          kind: 'report',
          buttonLabel: 'Open report',
          iconName: 'fa-solid fa-layer-group',
          onClick: () =>
            open(
              <AssignmentLineItemFeeRevenueByIndustry />,
              'Assgn. + Ln. I. Fee Revenue by Ind.',
              'reports_assignmentslineitemsfeerevenuebyindustry'
            ),
        },
      ],
    },
  ];
}
